// ** React Imports
import { lazy } from 'react';

const InsurancePrograms = [
  {
    path: 'insurance-programs',
    component: lazy(() => import('pages/insurance-programs')),
  },
];

export default InsurancePrograms;
